import { DcddMembershipPlanProp, stateStatusType,  } from './actionType';

// FetchVideoEpisodeState
export interface FetchDcddMembershipState {
    isLoading: boolean;
    error: string | null;
    membership: DcddMembershipPlanProp[] | null;
    status: stateStatusType | null;
}
export interface GenericDcddMembershipState {
    isLoading: boolean;
    error: string | null;
    status: stateStatusType | null;
}

export const initialDcddMembershipState: FetchDcddMembershipState = {
    isLoading: false,
    error: null,
    membership: null,
    status: null
};

export const initialGenericDcddMembershipState: GenericDcddMembershipState = {
    isLoading: false,
    error: null,
    status: null
};

export interface DcddMembershipState {
    dcddMembershipState: FetchDcddMembershipState;
    genericDcddMembershipState: GenericDcddMembershipState;
}

export const initialState: DcddMembershipState = {
    dcddMembershipState: initialDcddMembershipState,
    genericDcddMembershipState: initialGenericDcddMembershipState,
};


